import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-validated-number-input',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslatePipe],
  templateUrl: './validated-number-input.component.html',
  styleUrl: './validated-number-input.component.scss',
})
export class ValidatedNumberInputComponent {
  label = input.required<string>();
  inputFormControlName = input.required<string>();
  inputFormControl = input.required<FormControl>();
  validationTrainslations = input<{ [key: string]: string }>();
  leaveSpaceForValidation = input<boolean>(false);
  omitKeydownEnter = input<boolean>(false);
  placeholder = input<string>('');

  hasRequiredValidator(): string | boolean {
    return this.inputFormControl().hasValidator(Validators.required);
  }

  errorKeys(): string[] {
    const control = this.inputFormControl();
    return control.errors ? Object.keys(control.errors) : [];
  }

  getErrorMessage(errorKey: string): string {
    return this.validationTrainslations()?.[errorKey] ?? errorKey;
  }

  onEnterKey(event: Event): void {
    event.preventDefault();
  }
}
